import React from 'react';
import { Link } from 'react-router-dom';

const Icon = ({ d }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

const features = [
  { t: "OAuth 2.0 Authentication", d: "Secure BookBridge connection with automatic token refresh built in.", i: "M12 2l3 7h7l-5.5 4 2 7L12 16l-6.5 4 2-7L2 9h7z" },
  { t: "Multi-tenant Support", d: "Manage multiple BookBridge organizations per user out of the box.", i: "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2 M9 11a4 4 0 100-8 4 4 0 000 8z M23 21v-2a4 4 0 00-3-3.87 M16 3.13a4 4 0 010 7.75" },
  { t: "Full Accounting API", d: "Invoices, bills, payments, payroll, journal entries and more.", i: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8" },
  { t: "Financial Reports", d: "P&L, balance sheets, cash flow, AR/AP aging — generated on demand.", i: "M3 3v18h18 M7 14l4-4 4 4 6-6" },
  { t: "Swagger Docs", d: "Interactive API documentation included out of the box.", i: "M4 19.5A2.5 2.5 0 016.5 17H20 M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" },
  { t: "JWT + Cookie Auth", d: "Two auth methods supported with full session management.", i: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" },
];

const modules = [
  { n: "Authentication", d: "User accounts & sessions" },
  { n: "Accounting", d: "Core ledger operations" },
  { n: "Chart of Accounts", d: "Account hierarchy management" },
  { n: "Customers & Vendors", d: "Contact management" },
  { n: "Invoices & Bills", d: "Receivables & payables" },
  { n: "Payments", d: "Record & match payments" },
  { n: "Bank Accounts & Cards", d: "Banking integrations" },
  { n: "Inventory", d: "Stock & item tracking" },
  { n: "Tax Management", d: "Tax codes & rates" },
  { n: "Payroll", d: "Employees & runs" },
  { n: "Financial Reports", d: "P&L, BS, cash flow & aging" },
];

function Homepage() {
  return (
    <div className="bg-white">
      <header className="sticky top-0 z-50 bg-white border-b border-line shadow-sm">
        <div className="max-w-[1560px] mx-auto px-6 h-16 flex items-center justify-between">
          <Link className="flex items-center gap-2.5 font-bold text-lg" to="/">
            <span className="w-[34px] h-[34px] rounded-xl bg-gradient-to-br from-[#6366f1] to-[#8b5cf6] grid place-items-center text-white text-[14px] font-extrabold shadow-lg">B</span>
            <span className="bg-gradient-to-r from-[#6366f1] to-[#8b5cf6] bg-clip-text text-transparent">BookBridge</span>
          </Link>
          <nav className="flex items-center gap-3">
            <a className="hidden md:block px-4 py-2 text-muted font-medium text-sm rounded-xl hover:text-[#6366f1] hover:bg-[#f5f3ff] transition-all" href="#features">Features</a>
            <a className="hidden md:block px-4 py-2 text-muted font-medium text-sm rounded-xl hover:text-[#6366f1] hover:bg-[#f5f3ff] transition-all" href="https://qbo.api.xcelerateai-api.com/api-docs/">Documentation</a>
            <Link className="px-4 py-2 text-muted font-medium text-sm rounded-xl hover:text-[#6366f1] hover:bg-[#f5f3ff] transition-all" to="/contact-us">Contact</Link>
            <Link className="px-4 py-2 text-white font-medium text-sm rounded-xl bg-gradient-to-r from-[#6366f1] to-[#8b5cf6] hover:text-[#6366f1] hover:bg-[#f5f3ff] transition-all" to="/login">Login</Link>
          </nav>
        </div>
      </header>

      <section className="relative overflow-hidden py-28 md:py-36 bg-gradient-to-br from-[#faf5ff] via-white to-[#f0f9ff]">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzgwODBmZiIgc3Ryb2tlLXdpZHRoPSIwLjUiIG9wYWNpdHk9IjAuMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-40"></div>
        <div className="max-w-[900px] mx-auto px-6 relative text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[#e9d5ff] shadow-sm mb-6">
            <span className="w-2 h-2 rounded-full bg-gradient-to-r from-[#6366f1] to-[#8b5cf6] animate-pulse"></span>
            <span className="text-sm font-medium text-[#6366f1]">Seamless Integration Platform</span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#a855f7] bg-clip-text text-transparent leading-tight mb-6">Connect Your App to BookBridge</h1>
          <p className="mt-6 text-xl text-gray-600 max-w-[720px] mx-auto leading-relaxed">
            A production-ready OAuth 2.0 platform that handles authentication,
            token management, and complete accounting operations seamlessly.
          </p>
          <div className="mt-10 flex justify-center gap-4 flex-wrap">
            <a className="inline-flex items-center gap-2 h-14 px-8 rounded-xl font-semibold text-base bg-gradient-to-r from-[#6366f1] to-[#8b5cf6] text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all" href="https://qbo.api.xcelerateai-api.com/api-docs/">Get Started Free</a>
            <a className="inline-flex items-center gap-2 h-14 px-8 rounded-xl font-semibold text-base bg-white text-gray-700 border-2 border-gray-200 hover:border-[#6366f1] hover:text-[#6366f1] transition-all" href="#features">Explore Features</a>
            <Link className="inline-flex items-center gap-2 h-14 px-8 rounded-xl font-semibold text-base bg-white text-gray-700 border-2 border-gray-200 hover:border-[#6366f1] hover:text-[#6366f1] transition-all" to="/contact-us">Contact Us</Link>
          </div>
          <p className="mt-8 text-sm text-gray-500">Trusted by developers <span className="mx-2">•</span> Enterprise-ready <span className="mx-2">•</span> REST API</p>
        </div>
      </section>

      <section className="py-24 bg-white" id="features">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center max-w-[720px] mx-auto mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-gradient-to-r from-[#ede9fe] to-[#ddd6fe] text-[#6366f1] font-semibold text-sm mb-4">POWERFUL FEATURES</span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Everything you need for BookBridge</h2>
            <p className="mt-4 text-gray-600 text-lg">Enterprise-grade features with developer-friendly APIs and comprehensive documentation.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f) => (
              <div key={f.t} className="group p-8 bg-gradient-to-br from-white to-gray-50 border-2 border-gray-100 rounded-2xl hover:border-[#6366f1] hover:shadow-2xl hover:-translate-y-1 transition-all duration-300">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#6366f1] to-[#8b5cf6] grid place-items-center text-white mb-5 group-hover:scale-110 transition-transform"><Icon d={f.i} /></div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{f.t}</h3>
                <p className="text-gray-600 text-[15px] leading-relaxed">{f.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center max-w-[720px] mx-auto mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-gradient-to-r from-[#ede9fe] to-[#ddd6fe] text-[#6366f1] font-semibold text-sm mb-4">SIMPLE PROCESS</span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">Get started in 3 easy steps</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { t: "Register & Login", d: "Create your account with email and password. Quick setup in under 2 minutes." },
              { t: "Connect BookBridge", d: "Authorize via OAuth 2.0. Tokens are managed and refreshed automatically." },
              { t: "Start Building", d: "Access REST endpoints for invoices, customers, reports, and complete accounting data." },
            ].map((s, i) => (
              <div key={s.t} className="relative p-8 bg-white rounded-2xl shadow-lg border-2 border-gray-100 hover:border-[#6366f1] transition-all">
                <div className="absolute -top-4 left-8 w-10 h-10 rounded-full bg-gradient-to-br from-[#6366f1] to-[#8b5cf6] text-white grid place-items-center font-bold text-lg shadow-lg">{i + 1}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 mt-2">{s.t}</h3>
                <p className="text-gray-600 leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center max-w-[720px] mx-auto mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-gradient-to-r from-[#ede9fe] to-[#ddd6fe] text-[#6366f1] font-semibold text-sm mb-4">COMPLETE API</span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">11 comprehensive modules</h2>
            <p className="mt-4 text-gray-600 text-lg">Full coverage of BookBridge accounting operations</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {modules.map((m) => (
              <div key={m.n} className="flex items-center gap-4 p-6 bg-gradient-to-r from-white to-gray-50 border-2 border-gray-100 rounded-xl hover:border-[#6366f1] hover:shadow-lg transition-all group">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#6366f1] to-[#8b5cf6] grid place-items-center text-white flex-shrink-0 group-hover:scale-110 transition-transform"><Icon d="M9 11l3 3L22 4 M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" /></div>
                <div>
                  <div className="font-bold text-gray-900 text-base">{m.n}</div>
                  <div className="text-sm text-gray-600 mt-1">{m.d}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="relative py-20 px-10 bg-gradient-to-br from-[#6366f1] via-[#7c3aed] to-[#8b5cf6] rounded-3xl text-center text-white overflow-hidden shadow-2xl">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIwLjUiIG9wYWNpdHk9IjAuMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-30"></div>
            <div className="relative">
              <h2 className="text-4xl md:text-5xl font-extrabold mb-4">Ready to build with BookBridge?</h2>
              <p className="text-xl text-purple-100 max-w-2xl mx-auto mb-8">Start integrating powerful accounting features into your application today.</p>
              <div className="flex justify-center gap-4 flex-wrap">
                <a className="inline-flex items-center gap-2 h-14 px-8 rounded-xl font-bold text-base bg-white text-[#6366f1] shadow-xl hover:shadow-2xl hover:scale-105 transition-all" href="https://qbo.api.xcelerateai-api.com/api-docs/" target="_blank" rel="noreferrer">View API Documentation</a>
                <a className="inline-flex items-center gap-2 h-14 px-8 rounded-xl font-bold text-base bg-white/10 text-white border-2 border-white/30 hover:bg-white/20 transition-all" href="#features">Learn More</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="py-16 bg-gray-900 text-white">
        <div className="max-w-[1560px] mx-auto px-6">
          <div className="flex justify-between gap-12 flex-wrap items-start">
            <div className="max-w-[380px]">
              <div className="flex items-center gap-3 font-bold text-xl mb-4">
                <span className="w-[36px] h-[36px] rounded-xl bg-gradient-to-br from-[#6366f1] to-[#8b5cf6] grid place-items-center text-white text-[15px] font-extrabold shadow-lg">B</span>
                <span className="bg-gradient-to-r from-[#a78bfa] to-[#c4b5fd] bg-clip-text text-transparent">BookBridge</span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">The complete OAuth + accounting API platform for seamless BookBridge integration. Built for developers, trusted by enterprises.</p>
            </div>
            <div className="flex gap-12 flex-wrap">
              <div>
                <h4 className="font-semibold text-white mb-3">Resources</h4>
                <div className="flex flex-col gap-2">
                  <a href="https://qbo.api.xcelerateai-api.com/api-docs/" target="_blank" rel="noreferrer" className="text-gray-400 text-sm hover:text-[#a78bfa] transition-colors">API Documentation</a>
                  <a href="#features" className="text-gray-400 text-sm hover:text-[#a78bfa] transition-colors">Features</a>
                </div>
              </div>
              <div>
                <h4 className="font-semibold text-white mb-3">Legal</h4>
                <div className="flex flex-col gap-2">
                  <Link to="/privacy" className="text-gray-400 text-sm hover:text-[#a78bfa] transition-colors">Privacy Policy</Link>
                  <Link to="/terms" className="text-gray-400 text-sm hover:text-[#a78bfa] transition-colors">Terms of Service</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 pt-8 border-t border-gray-800 text-sm text-gray-400 flex justify-between flex-wrap gap-4">
            <span>© {new Date().getFullYear()} BookBridge. All rights reserved.</span>
            <span>Empowering developers worldwide</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Homepage;
